import styled from "styled-components";

export const Container = styled.div`
  @media screen and (max-width: 568px) {
    .header {
      flex-direction: column;
      gap: 20px;
      h3 {
        font-size: 15px;
        color: #2b2f38;
      }
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
    .texts {
      h3 {
        font-size: 32px;
        line-height: 44px;
        color: #2b2f38;
      }
      p {
        margin-top: 5px;
        line-height: 22px;
        font-size: 16px;
        color: #667085;
      }
    }

    .link-buttons {
      display: flex;
      gap: 10px;
      .see-more,
      .add-campaign {
        padding: 10px 16px;
        height: 40px;
        border: 1px solid #d0d5dd;
        border-radius: 8px;
        font-size: 14px;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        color: #344054;
      }
      .add-campaign {
        color: #fff;
        border: 1px solid #3730a3;
        background-color: #3730a3;
      }
    }
  }
`;
export const CardWrapper = styled.div`
margin-top: 30px;
  width: 100%;
  display: grid;
  gap: 20px;
  margin-bottom: 30px;
  //margin: auto;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 976px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
